export class ProverbsData {
 	static german() {
		return `adel verpflichtet
allen leuten recht getan, ist eine kunst, die niemand kann
aller anfang ist schwer
aller guten dinge sind drei
alles hat ein ende
alles hat seine zeit
alle wege führen nach rom
allzuviel ist ungesund
alte liebe rostet nicht
alter schützt vor torheit nicht
andere länder, andere sitten
an der frucht erkennt man den baum
arbeit adelt
armut ist keine schande
auf einen groben klotz gehört ein grober keil
aufgeschoben ist nicht aufgehoben
auf regen folgt sonnenschein
auge um auge, zahn um zahn
aus den augen, aus dem sinn
ausnahmen bestätigen die regel
aus schaden wird man klug
außen hui innen pfui
beharrlichkeit führt zum ziel
beim geld hört die freundschaft auf
bescheidenheit ist eine zier
besser spät als nie
besser zu früh als zu spät
blinder eifer schadet nur
blut ist dicker als wasser
borgen macht sorgen
da ist der wunsch der vater des gedankens
das auge isst mit
das glück ist mit den dummen
das letzte hemd hat keine taschen
das werk lobt den meister
den letzten beißen die hunde
den mutigen gehört die welt
der apfel fällt nicht weit vom stamm
der appetit kommt beim essen
der erfolg hat viele väter
der erste schritt ist immer der schwerste
der fisch stinkt vom kopf her
der frühe vogel fängt den wurm
der geist ist willig, aber das fleisch ist schwach
der glaube versetzt berge
der klügere gibt nach
der krug geht so lange zum brunnen, bis er bricht
der mensch denkt und gott lenkt
der mensch ist ein gewohnheitstier
der mensch lebt nicht vom brot allein
der prophet gilt nichts im eigenen land
der schein trügt
der teufel scheißt immer auf den größten haufen
der teufel steckt im detail
der ton macht die musik
der weg ist das ziel
der weg zur hölle ist mit guten vorsätzen gepflastert
der zweck heiligt die mittel
des einen glück ist des anderen leid
die augen sind der spiegel der seele
die dummen sterben nicht aus
die dümmsten bauern haben die dicksten kartoffeln
die geschmäcker sind verschieden
die hoffnung stirbt zuletzt
die katze lässt das mausen nicht
die konkurrenz schläft nicht
die letzten werden die ersten sein
die ratten verlassen das sinkende schiff
die sonne bringt es an den tag
die suppe, die man sich einbrockt, muss man auch auslöffeln
die wege des herrn sind unergründlich
die welt ist ein dorf
die zeit heilt alle wunden
dummheit und stolz wachsen auf einem holz
ehre wem ehre gebührt
ehrlich währt am längsten
eigenlob stinkt
eile mit weile
ein blindes huhn findet auch mal ein korn
eine hand wäscht die andere
eine kette ist nur so stark wie ihr schwächstes glied
eine krähe hackt der anderen kein auge aus
einem geschenkten gaul schaut man nicht ins maul
eine schwalbe macht noch keinen sommer
ein gutes gewissen ist ein sanftes ruhekissen
ein leerer sack bleibt nicht stehen
einmal ist immer das erste mal
einmal ist keinmal
ein unglück kommt selten allein
ein voller bauch studiert nicht gern
ende gut, alles gut
erfahrung ist der beste lehrmeister
erfahrung macht klug
erst denken, dann handeln
erst die arbeit, dann das vergnügen
es ist etwas faul im staate dänemark
es ist nicht alles gold was glänzt
es ist noch kein meister vom himmel gefallen
frisch gewagt ist halb gewonnen
früh übt sich, wer ein meister werden will
geben ist seliger denn nehmen
gebranntes kind scheut das feuer
gebt dem kaiser, was des kaisers ist, und gott, was gottes ist
geduld bringt rosen
gegen dummheit ist kein kraut gewachsen
gegensätze ziehen sich an
geld allein macht nicht glücklich
geld regiert die welt
geld stinkt nicht
geld verdirbt den charakter
gelegenheit macht diebe
geteilte freude ist doppelte freude
geteiltes leid ist halbes leid
getroffene hunde bellen
gleich und gleich gesellt sich gern
glück und glas, wie leicht bricht das
gottes mühlen mahlen langsam
grau ist alle theorie
gut ding braucht weile
guter rat ist teuer
handwerk hat goldenen boden
harte schale, weicher kern
hilf dir selbst, dann hilft dir gott
hochmut kommt vor dem fall
hunde, die bellen, beißen nicht
hunger ist der beste koch
im krieg und in der liebe ist alles erlaubt
im wein liegt wahrheit
in der not erkennt man seine freunde
in der not frisst der teufel fliegen
in der ruhe liegt die kraft
in einem gesunden körper wohnt ein gesunder geist
irren ist menschlich
ist die katze aus dem haus, tanzen die mäuse auf dem tisch
jedem tierchen sein pläsierchen
jeder bekommt, was er verdient
jeder hat seine stärken
jeder hat sein päckchen zu tragen
jeder ist seines glückes schmied
jeder ist sich selbst der nächste
jeder nach seinem geschmack
jeder sollte vor seiner eigenen tür kehren
jeder topf findet seinen deckel
jedes ding hat zwei seiten
keine antwort ist auch eine antwort
keine regel ohne ausnahme
keine rose ohne dornen
kein nachteil ohne vorteil
kindermund tut wahrheit kund
kinder und narren sagen die wahrheit
kleider machen leute
kleine kinder, kleine sorgen, große kinder, große sorgen
kleinvieh macht auch mist
knapp daneben ist auch vorbei
kommt zeit, kommt rat
lachen ist die beste medizin
lachen ist gesund
lege nicht alle eier in einen korb
lehrjahre sind keine herrenjahre
liebe deinen nächsten wie dich selbst
liebe geht durch den magen
liebe kann man nicht erzwingen
liebe macht blind
lieber den spatz in der hand als die taube auf dem dach
lieber ein ende mit schrecken als ein schrecken ohne ende
lügen haben kurze beine
man beißt nicht die hand, die einen füttert
man ist so alt, wie man sich fühlt
man kann die pferde zur tränke führen, saufen müssen sie selbst
man kann nicht auf zwei hochzeiten tanzen
man kann nicht gleichzeitig zwei herren dienen
man lernt nie aus
man muss das eisen schmieden, solange es heiß ist
man muss die menschen nehmen, wie sie sind
man sägt nicht den ast ab, auf dem man sitzt
man schlägt den sack und meint den esel
man soll aufhören, wenn es am schönsten ist
man soll das fell des bären nicht verteilen, bevor er erlegt ist
man soll den tag nicht vor dem abend loben
man soll die feste feiern, wie sie fallen
man sollte sich nicht zu früh freuen
mit der dummheit kämpfen götter selbst vergebens
mit speck fängt man mäuse
morgenstund hat gold im mund
müßiggang ist aller laster anfang
nachts sind alle katzen grau
neue besen kehren gut
nichts wird so heiß gegessen wie es gekocht wird
niemand ist unersetzlich
noch ist nicht aller tage abend
not kennt kein gebot
not lehrt beten
not macht erfinderisch
ohne fleiß kein preis
ordnung ist das halbe leben
ordnung muss sein
pack schlägt sich, pack verträgt sich
papier ist geduldig
pech im spiel, glück in der liebe
probieren geht über studieren
pünktlichkeit ist die höflichkeit der könige
rache ist süß
reden ist silber, schweigen ist gold
rom wurde auch nicht an einem tag erbaut
sag niemals nie
schadenfreude ist die schönste freude
scherben bringen glück
schlaf ist die beste medizin
schlechte beispiele verderben gute sitten
schuster bleib bei deinen leisten
sicher ist sicher
spare in der zeit, dann hast du in der not
steter tropfen höhlt den stein
stille wasser sind tief
totgesagte leben länger
trau, schau, wem
trautes heim, glück allein
über geschmack lässt sich streiten
übung macht den meister
umsonst ist nur der tod
undank ist der welt lohn
unkraut vergeht nicht
unter den blinden ist der einäugige könig
unwissenheit schützt vor strafe nicht
versprochen ist versprochen
vertrauen ist gut, kontrolle ist besser
viele hände, schnelles ende
viele hunde sind des hasen tod
viele köche verderben den brei
viel lärm um nichts
vier augen sehen mehr als zwei
volkes stimme ist gottes stimme
von nichts kommt nichts
vorbeugen ist besser als heilen
vorsicht ist besser als nachsicht
was der bauer nicht kennt, frisst er nicht
was du heute kannst besorgen, das verschiebe nicht auf morgen
was du nicht willst, das man dir tu, das füg auch keinem ander(e)n zu
was hänschen nicht lernt, lernt hans nimmermehr
was lange währt, wird endlich gut
was man nicht im kopf hat, muss man in den beinen haben
was nicht ist, kann ja noch werden
was nichts kostet, ist nichts wert
was sein muss, muss sein
was sich liebt, das neckt sich
was siehst du den splitter im auge deines bruders und den balken im eigenen nimmst du nicht wahr
was uns nicht umbringt, macht uns stark
wem gott ein amt gibt, dem gibt er auch verstand
weniger ist mehr
wenn der berg nicht zum propheten kommt, muss der prophet zum berg kommen
wenn die waffen sprechen, schweigen die musen
wenn es dem esel zu wohl wird, geht er aufs eis
wenn zwei das gleiche tun, ist es noch lange nicht dasselbe
wenn zwei sich streiten, freut sich der dritte
wer anderen eine grube gräbt, fällt selbst hinein
wer a sagt muss auch b sagen
wer billig kauft, kauft teuer
wer das schwert nimmt, wird durch das schwert umkommen
wer den pfennig nicht ehrt, ist des talers nicht wert
wer den schaden hat, braucht für den spott nicht zu sorgen
wer einmal lügt, dem glaubt man nicht, und wenn er auch die wahrheit spricht
wer ernten will, muss säen
wer hoch steigt, fällt tief
wer im glashaus sitzt, sollte nicht mit steinen werfen
wer nicht arbeitet, soll auch nicht essen
wer nicht hören will, muss fühlen
wer nichts macht, macht nichts falsch
wer rastet, der rostet
wer schläft, sündigt nicht
wer schnell gibt, gibt doppelt
wer schön sein will, muss leiden
wer schweigt, stimmt zu
wer sich in gefahr begibt, kommt darin um
wer sucht, der findet
wer wagt, gewinnt
wer wind sät, wird sturm ernten
wer zahlt, bestimmt die musik
wer zahlt, schafft an
wer zuerst kommt, mahlt zuerst
wer zuletzt lacht, lacht am besten
wer zu spät kommt, den bestraft das leben
wes brot ich ess, des lied ich sing
wes das herz voll ist, des geht der mund über
wie der herr, so s gescherr
wie der vater, so der sohn
wie du mir, so ich dir
wie gewonnen, so zerronnen
wie man in den wald hineinruft, so schallt es heraus
wie man sich bettet, so liegt man
wir sitzen alle in einem boot
wissen ist macht
wo ein wille ist, ist auch ein weg
wo gehobelt wird, fallen späne
wo kein kläger, da kein richter
wo licht ist, ist auch schatten
wo nichts ist, hat der kaiser sein recht verloren
wo rauch ist, ist auch feuer
zahlen lügen nicht
zeig mir deine freunde und ich sag dir, wer du bist
zeit ist geld`
	}

	static english() {
		return `a bad penny always turns up
		a barking dog never bites
		a bird in the hand is worth two in the bush
		a cat may look at a king
		a chain is only as strong as its weakest link
		a change is as good as a rest
		a dog is a man's best friend
		a drowning man will clutch at a straw
		a fish always rots from the head down
		a fool and his money are soon parted
		a friend in need is a friend indeed
		a golden key can open any door
		a good beginning makes a good ending
		a good man is hard to find
		a house divided against itself cannot stand
		a person is known by the company he keeps
		a house is not a home
		a journey of a thousand miles begins with a single step
		a leopard cannot change its spots
		a little knowledge is a dangerous thing
		a little learning is a dangerous thing
		a little of what you fancy does you good
		a man is known by his friends
		a man who is his own lawyer has a fool for his client
		a miss is as good as a mile
		a new broom sweeps clean
		a nod's as good as a wink to a blind horse
		a penny saved is a penny earned
		a picture paints a thousand words
		a place for everything and everything in its place
		a poor workman always blames his tools
		a person is known by the company he keeps
		a problem shared is a problem halved
		a prophet is not recognized in his own land
		a rising tide lifts all boats
		a rolling stone gathers no moss
		a soft answer turneth away wrath
		a stitch in time saves nine
		a swarm in may is worth a load of hay; a swarm in june is worth a silver spoon; but a swarm in july is not worth a fly
		a thing of beauty is a joy forever
		a trouble shared is a trouble halved
		a volunteer is worth twenty pressed men
		a watched pot never boils
		a woman is only a woman, but a good cigar is a smoke
		a woman's place is in the home
		a woman's work is never done
		a word to the wise is enough
		absence makes the heart grow fonder
		absolute power corrupts absolutely
		accidents will happen (in the best-regulated families).
		actions speak louder than words
		adversity makes strange bedfellows
		after a storm comes a calm
		all good things come to he who waits
		all good things must come to an end
		all is grist that comes to the mill
		all publicity is good publicity
		all roads lead to rome
		all that glisters is not gold
		all that glitters is not gold
		all the world loves a lover
		all things come to those who wait
		all things must pass
		all work and no play makes jack a dull boy
		all you need is love
		all's fair in love and war
		all's for the best in the best of all possible worlds
		all's well that ends well
		a miss is as good as a mile
		an apple a day keeps the doctor away
		an army marches on its stomach
		an englishman's home is his castle
		an eye for an eye, a tooth for a tooth
		an ounce of prevention is worth a pound of cure
		another day, another dollar
		any port in a storm
		appearances can be deceptive
		april is the cruellest month
		april showers bring forth may flowers
		as thick as thieves
		as you make your bed, so you must lie upon it
		as you sow so shall you reap
		ashes to ashes dust to dust
		ask a silly question and you'll get a silly answer
		ask no questions and hear no lies
		attack is the best form of defence
		bad money drives out good
		bad news travels fast
		barking dogs seldom bite
		be careful what you wish for
		beat swords into ploughshares
		beauty is in the eye of the beholder
		beauty is only skin deep
		beggars should not be choosers
		behind every great man there's a great woman
		better late than never
		better safe than sorry
		better the devil you know than the devil you don't
		better to have loved and lost than never to have loved at all
		better to light a candle than to curse the darkness
		better to remain silent and be thought a fool that to speak and remove all doubt
		beware of greeks bearing gifts
		beware the ides of march
		big fish eat little fish
		birds of a feather flock together
		blessed are the peacemakers
		blood is thicker than water
		blue are the hills that are far away
		boys will be boys
		brevity is the soul of wit
		business before pleasure
		caesar's wife must be above suspicion
		carpe diem (pluck the day; seize the day)
		charity begins at home
		charity covers a multitude of sins
		cheaters never win and winners never cheat
		cheats never prosper
		children and fools tell the truth
		children should be seen and not heard
		christmas comes but once a year
		cleanliness is next to godliness
		clothes maketh the man
		cold hands, warm heart
		comparisons are odious
		count your blessings
		cowards may die many times before their death
		crime doesn't pay
		cut your coat to suit your cloth
		dead men tell no tales
		devil take the hindmost
		different strokes for different folks
		discretion is the better part of valour
		distance lends enchantment to the view
		do as i say, not as i do
		do as you would be done by
		do unto others as you would have them do to you
		don't bite the hand that feeds you
		don't burn your bridges behind you
		don't cast your pearls before swine
		don't change horses in midstream
		don't count your chickens before they are hatched
		don't cross the bridge till you come to it
		don't cut off your nose to spite your face
		don't get mad, get even
		don't keep a dog and bark yourself
		don't leave your manners on the doorstep
		don't let the bastards grind you down
		don't let the cat out of the bag
		don't let the grass grow under your feet
		don't meet troubles half-way
		don't mix business with pleasure
		don't put all your eggs in one basket
		don't put the cart before the horse
		don't put new wine into old bottles
		don't rock the boat
		don't shoot the messenger
		don't spoil the ship for a ha'porth of tar
		don't shut the stable door after the horse has bolted
		don't sweat the small stuff
		don't throw pearls to swine
		don't teach your grandma to suck eggs
		don't throw the baby out with the bathwater
		don't trust anyone over thirty
		don't try to run before you can walk
		don't try to walk before you can crawl
		don't upset the apple-cart
		don't wash your dirty linen in public
		doubt is the beginning not the end of wisdom
		early to bed and early to rise, makes a man healthy, wealthy and wise
		each to their own
		east is east, and west is west
		east, west, home's best
		easy come, easy go
		eat, drink and be merry, for tomorrow we die
		empty vessels make the most noise
		enough is as good as a feast
		enough is enough
		even a worm will turn
		every cloud has a silver lining
		every dog has its day
		every little helps
		every man for himself, and the devil take the hindmost
		every man has his price
		every picture tells a story
		every stick has two ends
		everyone wants to go to heaven but nobody wants to die
		everything comes to him who waits
		failing to plan is planning to fail
		faint heart never won fair lady
		fair exchange is no robbery
		faith will move mountains
		familiarity breeds contempt
		feed a cold and starve a fever
		fight fire with fire
		fight the good fight
		finders keepers, losers weepers
		fine words butter no parsnips
		first come, first served
		first impressions are the most lasting
		first things first
		fish always stink from the head down
		fish and guests smell after three days
		flattery will get you nowhere
		fools rush in where angels fear to tread
		for everything there is a season
		for want of a nail the shoe was lost; for want of a shoe the horse was lost; and for want of a horse the man was lost
		forewarned is forearmed
		forgive and forget
		fortune favours the brave
		from the sublime to the ridiculous is only one step
		genius is an infinite capacity for taking pains
		genius is one percent inspiration, ninety-nine percent perspiration
		give a man a fish and you will feed him for a day...
		give a dog a bad name and hang him
		give a man enough rope and he will hang himself
		give credit where credit is due
		give the devil his due
		go the extra mile
		god helps those who help themselves
		good fences make good neighbours
		good talk saves the food
		good things come in small packages
		good things come to those who wait
		great minds think alike
		half a loaf is better than no bread
		handsome is as handsome does
		hard cases make bad law
		hard work never did anyone any harm
		haste makes waste
		he that goes a-borrowing, goes a-sorrowing
		he who can does, he who cannot, teaches
		he who fights and runs away, may live to fight another day
		he who hesitates is lost
		he who laughs last laughs longest
		he who lives by the sword shall die by the sword
		he who pays the piper calls the tune
		he who sups with the devil should have a long spoon
		hell hath no fury like a woman scorned
		hindsight is always twenty-twenty
		history repeats itself
		hold with the hare and run with the hounds - you can't
		home is where the heart is
		honesty is the best policy
		hope springs eternal
		horses for courses
		if anything can go wrong, it will
		if a job is worth doing it is worth doing well
		if at first you don't succeed try, try and try again
		if god had meant us to fly he'd have given us wings
		if ifs and ands were pots and pans there'd be no work for tinkers
		if it ain't broke, don't fix it
		if life deals you lemons, make lemonade
		if the cap fits, wear it
		if the mountain won't come to mohammed, then mohammed must go to the mountain
		if the shoe fits, wear it
		if wishes were horses, beggars would ride
		if you build it they will come
		if you can't be good, be careful
		if you can't beat em, join em
		if you can't stand the heat get out of the kitchen
		if you lie down with dogs, you will get up with fleas
		if you pay peanuts, you get monkeys
		if you want a thing done well, do it yourself
		ignorance is bliss
		imitation is the sincerest form of flattery
		in for a penny, in for a pound
		in the kingdom of the blind the one eyed man is king
		in the midst of life we are in death
		into every life a little rain must fall
		it ain't over till the fat lady sings
		it goes without saying
		it is best to be on the safe side
		it is better to give than to receive
		it is easy to be wise after the event
		it never rains but it pours
		it takes a thief to catch a thief
		it takes all sorts to make a world
		it takes one to know one
		it takes two to tango
		it's all grist to the mill
		it's an ill wind that blows no one any good
		it's better to give than to receive
		it's better to have loved and lost than never to have loved at all
		it's better to light a candle than curse the darkness
		it's better to travel hopefully than to arrive
		it's never too late
		it's no use crying over spilt milk
		it's no use locking the stable door after the horse has bolted
		it's the early bird that catches the worm
		it's the empty can that makes the most noise
		it's the singer not the song
		it's the squeaky wheel that gets the grease
		jack of all trades, master of none
		judge not, that ye be not judged
		keep your chin up
		keep your friends close and your enemies closer
		keep your powder dry
		know which side your bread is buttered
		laugh and the world laughs with you, weep and you weep alone
		laughter is the best medicine
		least said, soonest mended
		less is more
		let bygones be bygones
		let not the sun go down on your wrath
		let sleeping dogs lie
		let the buyer beware
		let the dead bury the dead
		let the punishment fit the crime
		let well alone
		life begins at forty
		life is just a bowl of cherries
		life is what you make it
		life's not all beer and skittles
		lightning never strikes twice in the same place
		like father, like son
		little pitchers have big ears
		little strokes fell great oaks
		little things please little minds
		live and learn
		live for today for tomorrow never comes
		look before you leap
		love of money is the root of all evil
		love is blind
		love makes the world go round
		love thy neighbour as thyself
		love will find a way
		make hay while the sun shines
		make love not war
		man does not live by bread alone
		manners maketh man
		many a little makes a mickle
		many a mickle makes a muckle
		many a true word is spoken in jest
		many are called but few are chosen
		many hands make light work
		march comes in like a lion, and goes out like a lamb
		march winds and april showers bring forth may flowers
		marriages are made in heaven
		marry in haste, repent at leisure
		might is right
		mighty oaks from little acorns grow
		misery loves company
		moderation in all things
		monday's child is fair of face,
		tuesday's child is full of grace,
		wednesday's child is full of woe,
		thursday's child has far to go,
		friday's child is loving and giving,
		saturday's child works hard for its living,
		and a child that's born on the sabbath day
		is fair and wise and good and gay.
		money doesn't grow on trees
		money is the root of all evil
		money isn't everything
		money makes the world go round
		money talks
		more haste, less speed
		music has charms to soothe the savage breast
		nature abhors a vacuum
		necessity is the mother of invention
		needs must when the devil drives
		ne'er cast a clout till may be out
		never give a sucker an even break
		never go to bed on an argument
		never judge a book by its cover
		never let the sun go down on your anger
		never look a gift horse in the mouth
		never put off until tomorrow what you can do today
		never speak ill of the dead
		never tell tales out of school
		nine tailors make a man
		no man can serve two masters
		no man is an island
		no names, no pack-drill
		no news is good news
		no one can make you feel inferior without your consent
		no pain, no gain
		no rest for the wicked
		nothing new under the sun
		nothing is certain but death and taxes
		nothing succeeds like success
		nothing ventured, nothing gained
		oil and water don't mix
		old soldiers never die, they just fade away
		once a thief, always a thief
		once bitten, twice shy
		one good turn deserves another
		one half of the world does not know how the other half lives
		one hand washes the other
		one man's meat is another man's poison
		one might as well be hanged for a sheep as a lamb
		one law for the rich and another for the poor
		one swallow does not make a summer
		one volunteer is worth ten pressed men
		one year's seeding makes seven years weeding
		only fools and horses work
		opportunity never knocks twice at any man's door
		opposites attract
		out of sight, out of mind
		parsley seed goes nine times to the devil
		patience is a virtue
		pearls of wisdom
		penny wise and pound foolish
		people who live in glass houses shouldn't throw stones
		physician, heal thyself
		possession is nine points of the law
		power corrupts; absolute power corrupts absolutely
		practice makes perfect
		practice what you preach
		prevention is better than cure
		pride goes before a fall
		procrastination is the thief of time
		put your best foot forward
		quid pro quo
		rain before seven, fine before eleven
		red sky at night shepherd's delight; red sky in the morning, shepherd's warning
		revenge is a dish best served cold
		revenge is sweet
		rob peter to pay paul
		rome wasn't built in a day
		see a pin and pick it up, all the day you'll have good luck; see a pin and let it lie, bad luck you'll have all day
		see no evil, hear no evil, speak no evil
		seeing is believing
		seek and ye shall find
		set a thief to catch a thief
		share and share alike
		shrouds have no pockets
		silence is golden
		slow but sure
		softly, softly, catchee monkey
		spare the rod and spoil the child
		speak as you find
		speak softly and carry a big stick
		sticks and stones may break my bones, but words will never hurt me
		still waters run deep
		strike while the iron is hot
		stupid is as stupid does
		success has many fathers, while failure is an orphan
		take care of the pence and the pounds will take care of themselves
		talk is cheap
		talk of the devil, and he is bound to appear
		tell the truth and shame the devil
		that which does not kill us makes us stronger
		the age of miracles is past
		the apple never falls far from the tree
		the best defence is a good offence
		the best is the enemy of the good
		the best-laid schemes of mice and men gang aft agley
		the best things in life are free
		the bigger, the better
		the bigger they are, the harder they fall
		the bottom line is the bottom line
		the boy is father to the man
		the bread always falls buttered side down
		the child is the father of the man
		the cobbler always wears the worst shoes
		the course of true love never did run smooth
		the customer is always right
		the darkest hour is just before the dawn
		the devil makes work for idle hands to do
		the devil is in the details
		the devil looks after his own
		the early bird catches the worm
		the end justifies the means
		the exception which proves the rule
		the fat is in the fire
		the female of the species is more deadly than the male
		the fruit does not fall far from the tree
		the good die young
		the grass is always greener on the other side of the fence
		the hand that rocks the cradle rules the world
		the husband is always the last to know
		the labourer is worthy of his hire
		the law is an ass
		the leopard does not change his spots
		the longest journey starts with a single step
		the more the merrier
		the more things change, the more they stay the same
		the only good indian is a dead indian
		the opera ain't over till the fat lady sings
		the pen is mightier than sword
		the price of liberty is eternal vigilance
		the proof of the pudding is in the eating
		the road to hell is paved with good intentions
		the shoemaker's son always goes barefoot
		the squeaking wheel gets the grease
		the truth will out
		the wages of sin is death
		the way to a man's heart is through his stomach
		the whole is greater than the sum of the parts
		there are more ways of killing a cat than choking it with cream
		there are none so blind as those, that will not see
		there are two sides to every question
		there but for the grace of god, go i
		there's a time and a place for everything
		there's an exception to every rule
		there's always more fish in the sea
		there's honour among thieves
		there's many a good tune played on an old fiddle
		there's many a slip 'twixt cup and lip
		there's more than one way to skin a cat
		there's no accounting for tastes
		there's no fool like an old fool
		there's no place like home
		there's no smoke without fire
		there's no such thing as a free lunch
		there's no such thing as bad publicity
		there's no time like the present
		there's none so blind as those who will not see
		there's none so deaf as those who will not hear
		there's nowt so queer as folk
		there's one born every minute
		there's safety in numbers
		they that sow the wind, shall reap the whirlwind
		third time lucky
		those who do not learn from history are doomed to repeat it
		those who live in glass houses shouldn't throw stones
		those who sleep with dogs will rise with fleas
		thou shalt not kill
		time and tide wait for no man
		time flies
		time is a great healer
		time is money
		time will tell
		'tis better to have loved and lost, than never to have loved at all
		to err is human; to forgive divine
		to every thing there is a season
		to the victor go the spoils
		to travel hopefully is a better thing than to arrive
		tomorrow is another day
		tomorrow never comes
		too many cooks spoil the broth
		truth is stranger than fiction
		truth will out
		two blacks don't make a white
		two heads are better than one
		two is company, but three's a crowd
		two wrongs don't make a right
		variety is the spice of life
		virtue is its own reward
		walls have ears
		walnuts and pears you plant for your heirs
		waste not want not
		what can't be cured must be endured
		what goes up must come down
		what you lose on the swings you gain on the roundabouts
		what's sauce for the goose is sauce for the gander
		when in rome, do as the romans do
		when the cat's away the mice will play
		when the going gets tough, the tough get going
		when the oak is before the ash, then you will only get a splash; when the ash is before the oak, then you may expect a soak
		what the eye doesn't see, the heart doesn't grieve over
		where there's a will there's a way
		where there's muck there's brass
		while there's life there's hope
		whom the gods love die young
		why keep a dog and bark yourself?
		women and children first
		wonders will never cease
		work expands so as to fill the time available
		worrying never did anyone any good
		you are never too old to learn
		you are what you eat
		you can choose your friends but you can't choose your family
		you can have too much of a good thing
		you can lead a horse to water, but you can't make it drink
		you can't have your cake and eat it too
		you can't get blood out of a stone
		you can't get blood out of a turnip
		you can't hold with the hare and run with the hounds
		you can't make a silk purse from a sow's ear
		you can't make an omelette without breaking eggs
		you can't make bricks without straw
		you can't run with the hare and hunt with the hounds
		you can't take it with you when you die
		you can't teach an old dog new tricks
		you can't judge a book by its cover
		you can't win them all
		you catch more flies with honey than with vinegar
		you pays your money and you takes your choice
		you reap what you sow
		you win some, you lose some
		youth is wasted on the young`
	}
};
